import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterAscending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFilterAscending"><Path d="M14.5 10.5V8.75L16.75 3.5H18.25L20.5 8.75V10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 13.5H20.5V14.0833L14.5 19.9167V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 17.5L6.5 20.5L9.5 17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15 8.75H20" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 3.5V20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFilterAscending;
